var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#2b579a;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Word_48x1_5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Word_48",
    "data-name": "Word 48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37,
    y: 12,
    width: 30,
    height: 48,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,13V59H38V13H66m0-2H38a2,2,0,0,0-2,2V59a2,2,0,0,0,2,2H66a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38,
    y: 19,
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38,
    y: 25,
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38,
    y: 31,
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38,
    y: 37,
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38,
    y: 43,
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38,
    y: 49,
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,4,4,11V61l38,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,26l-4.34.25L27.12,40.07q-.05.27-.1.55t-.08.56q0,.28-.06.57t0,.59H26.8q0-.37-.06-.69t-.07-.6q0-.28-.07-.5t-.08-.41L23.61,26.6l-4.1.24-3,13q-.07.3-.13.59t-.1.57q0,.28-.07.55t0,.54h-.07q0-.36,0-.67t0-.59q0-.28-.06-.51T16,39.83L13.74,27.16,10,27.38l4,18.76,4.15.24L21,33.84q.05-.23.09-.48t.08-.53q0-.28.07-.58t.06-.63h0q0,.32,0,.61t.06.58q0,.28.08.54t.1.5l2.87,12.9L29,47l5-21"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.eb9a58a5ffc8c2e94c1a0bcc7555e54f.svg";
export { ForwardRef as ReactComponent };